import { render, staticRenderFns } from "./SharedForm.vue?vue&type=template&id=5b838ef8"
import script from "./SharedForm.vue?vue&type=script&lang=js"
export * from "./SharedForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports